/* Svensk katalog for locale-bank-misc-no.js (del 1 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'bank.analysis.running': 'Analyserar …',
  'bank.analysis.completed': 'Analyserad av SuperPlumma',
  'bank.analysis.start': 'Starta analys',
  'bank.analysis.retry': 'Försök med analysen igen',
  'bank.periodImport.dropFile': 'Släpp bankfilen här',
  'bank.periodImport.missingMonth': 'Saknar kontoutdrag för {{period}}',
  'bank.periodImport.monthUploadHelp': 'Ladda upp CSV, PDF eller XLSX för {{account}}. Filen kan täcka en eller flera månader, oavsett vilken månad du står i. Bankraderna fördelas automatiskt på rätt månad efter datum. Du kan också komplettera en tidigare import med ett nytt kontoutdrag.',
  'bank.periodImport.title': 'Ladda upp bankfil',
  'bank.periodImport.help': 'Ladda upp transaktioner eller kontoutdrag för en eller flera månader. Uppladdningen är oberoende av vilken månad du har valt.',
  'bank.periodImport.chooseAccount': 'Välj bankkonto',
  'bank.periodImport.coverageHelp': 'Kontrollera exportens period. Första och sista transaktionsdatum är bara ett förslag; dagar utan transaktioner kan också ingå.',
  'bank.periodImport.from': 'Export från och med',
  'bank.periodImport.to': 'Export till och med',
  'bank.periodImport.confirmCoverage': 'Filen innehåller alla bankrörelser under denna period, utan sök- eller beloppsfilter.',
  'bank.periodImport.closing': 'Utgående banksaldo (UB)',
  'bank.periodImport.balanceHelp': 'Saldona är valfria vid import. Använd bankens bokförda saldo direkt före startdatum och vid slutet av slutdatumet. Lämna fältet tomt om saldot är okänt. Ett senare kontoutdrag kan komplettera med IB/UB.',
  'bank.periodImport.preview': 'Kontrollera import',
  'bank.periodImport.save': 'Importera bankfil',
  'bank.periodImport.continue': 'Fortsätt där jag var',
  'bank.periodImport.process': 'Behandla hela perioden',
  'bank.periodImport.result': '{{added}} nya transaktioner · {{matched}} igenkända',
  'bank.periodImport.preserved': 'Tidigare behandling, konteringar och verifikationskopplingar har bevarats.',
  'bank.periodImport.fileMissing': 'Transaktionerna har sparats, men originalfilen kunde inte sparas. Ladda upp filen igen för att bevara dokumentationen.',
  'bank.periodImport.monthLines': '{{count}} rader',
  'bank.periodImport.balanceFound': 'UB registrerat',
  'bank.periodImport.balanceMissing': 'Banksaldo saknas',
  'bank.periodImport.chooseMatch': 'Välj befintlig transaktion med annan text',
  'bank.periodImport.newTransaction': 'Detta är en egen, ny transaktion',
  'bank.periodImport.worklist': 'Bank · samlad arbetslista',
  'bank.periodImport.worklistHelp': 'Behandla raderna löpande över månaderna. Varje månad har fortfarande egen saldokontroll och avstämning.',
  'bank.periodImport.needBalances': 'Banksaldo saknas. Du kan behandla raderna nu och komplettera med kontoutdrag eller dokumenterad IB/UB före avstämning.',
  'bank.periodImport.partial': 'Detta är en ofullständig månad. Behandla raderna nu och komplettera resten av månaden innan den färdigställs.',
  'bank.periodImport.files': 'Importerade originalfiler',
  'bank.periodImport.openPeriods': 'Öppna importerade perioder',
  'bank.control.ledgerDifference': '{{month}}: Bokförd UB {{booked}}, bankens UB {{bank}}. Avvikelse {{difference}}. Månaden måste kontrolleras på nytt.',
  'bank.control.openingLedgerDifference': '{{month}}: Bankens IB {{bank}}, IB i huvudboken {{booked}}. Avvikelse {{difference}}. Registrera en balanserad ingående balans under Bokföring innan avstämningen färdigställs.',
  'bank.control.ledgerMismatchTitle': 'Avvikelse mot huvudboken',
  'bank.archiveLedgerMismatch': 'Kan inte arkivera: bokfört saldo per {{date}} är {{booked}} kr, medan bankens saldo är {{bank}} kr. Avvikelse {{difference}} kr.',
  'bank.statementDiscrepancy': 'Utdragsavvikelse',
  'bank.balanceDiscrepancy': 'Saldoavvikelse',
  'bank.balanceDiscrepancyHelp': 'Skillnaden mellan bokfört saldo och bankens utgående saldo.',
  'bank.removedLineCannotBook': 'En felläst bankrad som har tagits bort från avstämningen kan inte bokföras.',
  'bank.control.missingBalance': '{{month}}: Kontoutdraget saknar UB. Bokförd UB är {{booked}}. Saldona har inte kontrollerats mot varandra.',
  'bank.control.ready': 'Kontoutdragen täcker perioden och är avstämda.',
  'bank.control.openingSetupMissing': '{{account}} saknar startdatum eller startsaldo. Fyll i båda i bankinställningarna; skriv 0 om saldot var noll.',
  'bank.control.needsReview': 'Bankkontrollen har ofullständigt startunderlag, saknade kontoutdrag, ej avstämda perioder, saldoavvikelser eller konteringar före startsaldo.',
  'bank.control.missing': 'Saknar kontoutdrag för {{year}}: {{months}}.',
  'bank.control.unsettled': 'Kontoutdrag har laddats upp men inte stämts av färdigt för {{year}}: {{months}}.',
  'bank.control.existingBeforeStart': '{{count}} kontering(ar) är daterade före startsaldo {{date}}. Kontrollera konteringarna och startsaldot i bankinställningarna. Startsaldot ändras inte automatiskt av tidigare konteringar.',
  'bank.control.postingBeforeStart': 'Konteringen är daterad före startsaldot för bankkonto {{account}} ({{date}}). Kontrollera datum och startsaldo i bankinställningarna innan du bokför.',
  'bank.patternBased': 'Baserat på tidigare mönster',
  'bank.patternTitle': 'Tidigare mönster',
  'bank.patternExplanation': 'Plumme föreslår denna behandling eftersom liknande bankrader tidigare har bokförts på samma sätt. Förslaget måste fortfarande godkännas. Du kan stoppa mönstret utan att ändra tidigare konteringar.',
  'bank.patternVariableAmounts': 'Plumme kommer ihåg typ och konto, men återanvänder inte tidigare amortering, ränta eller avgift. Beloppen måste kontrolleras mot underlaget varje gång.',
  'bank.patternStop': 'Använd inte mönstret',
  'bank.patternStopped': 'Mönstret har stoppats',
  'bank.patternStopFailed': 'Det gick inte att stoppa mönstret.',
  'bank.backToYearClosing': 'Tillbaka till bokslut',
  'bank.editEntry': 'Redigera kontering',
  'bank.bankLine': 'Bankrad',
  'bank.saveAndPost': 'Spara och bokför',
  'bank.readFrom': 'Informationen är avläst från',
  'bank.voucherType': 'Verifikationstyp',
  'bank.purchaseVoucher': 'Inköpsverifikation',
  'bank.salesVoucher': 'Försäljningsverifikation',
  'bank.counterparty': 'Motpart',
  'bank.supplierOrParty': 'Leverantör / motpart',
  'bank.businessAccount': 'Företagskonto',
  'bank.paidPrivately': 'Privat betalt',
  'bank.uploadOrForward': 'Ladda upp eller vidarebefordra verifikationer via e-post — vi läser av det vi kan.',
  'bank.uploadedReceived': 'Uppladdad/mottagen',
  'bank.searchVouchers': 'Sök i verifikationer — filnamn, PDF, bild…',
  'bank.noInboxVouchers': 'Inga verifikationer i inkorgen ännu',
  'bank.noInboxVouchersHelp': 'Ladda upp en verifikation eller vidarebefordra leverantörsfakturor till verifikationsadressen.',
  'bank.allMonths': 'Alla månader',
  'bank.uploading': 'Laddar upp …',
  'bank.uploadingCount': 'Laddar upp {{done}}/{{total}} …',
  'bank.analyzingCount': 'Analyserar {{done}}/{{total}} …',
  'bank.dragToReorder': 'Dra för att ändra ordning',
  'bank.editTheEntry': 'Redigera konteringen',
  'bank.moveToTrash': 'Flytta till papperskorgen',
  'bank.dropFilesHere': 'Släpp filerna här',
  'bank.weReadWhatWeCan': 'Vi läser av det vi kan',
  'bank.deleteForeverTitle': 'Ta bort för gott?',
  'bank.deleteForever': 'Ja, ta bort permanent',
  'km.time': 'Tid',
  'km.avgSpeed': 'Snitthastighet',
  'km.useDistance': 'Använd sträcka',
  'km.searching': 'Söker...',
  'km.from': 'Från',
  'km.to': 'Till',
  'km.resolvingAddress': 'Hittar adress...',
  'km.gpsGapTitle': 'Lucka i GPS-spåret',
  'km.gpsGap': 'Spårningen tappade positionen under resan, och {km} km har inte tagits med. Kontrollera kilometrarna innan du sparar resan.',
  'km.sub': 'Registrera resor och håll koll på milersättningen.',
  'km.newTripOrLog': 'Ny resa / Körjournal',
  'km.newTripOrLogHelp': '”Ny resa” registrerar en ny resa. ”Körjournal” visar en översikt över alla resor du har fört, med total sträcka och avdrag.',
  'km.tripDetails': 'Detaljer för resan',
  'km.tripDetailsHelp': 'Fyll i uppgifterna som dokumenterar resan: datum, syfte (varför du körde), från- och till-plats samt antal kilometer. Syftet är viktigt — resan måste vara tjänsterelaterad för att ge avdrag.',
  'km.purposePh': 'T.ex. kundmöte hos Lunde & Vik',
  'km.purposeQuickPicks': 'Snabbval',
  'km.returnTrip': 'Tur och retur',
  'km.returnTripHelp': 'Kryssa i när du körde samma väg tillbaka. Kilometrarna och avdraget fördubblas, och resan dokumenteras som tur och retur i körjournalen.',
  'km.returnTripRow': 'Tur och retur',
  'km.perLeg': 'Enkel väg',
  'km.removeStop': 'Ta bort stopp',
  'km.addStop': 'Lägg till stopp',
  'km.addStopHelp': 'Lägg till ett stopp mellan start och destination — praktiskt när resan går via flera platser. Varje stopp blir en del av rutten som dokumenteras.',
  'km.calcAuto': 'Beräkna km automatiskt',
  'km.calcAutoHelp': 'Räknar automatiskt ut antal kilometer mellan från-, stopp- och till-plats med hjälp av karta, så att du slipper slå upp avståndet själv.',
  'km.ratePerKm': 'Sats per km',
  'km.ratePerKmHelp': 'Statens sats för milersättning per kilometer. Plumme använder automatiskt den gällande satsen för att räkna ut avdraget.',
  'km.registeredDistance': 'Registrerad sträcka',
  'km.registeredDistanceHelp': 'Antal kilometer du har angett för den här resan.',
  'km.deductionAmount': 'Avdragsbelopp',
  'km.deductionAmountHelp': 'Kilometer gånger satsen — det skattefria belopp du kan få i milersättning för resan.',
  'km.saveHelp': 'Sparar resan i körjournalen. Den räknas med i årets totala sträcka och avdrag, och kan dokumenteras vid en eventuell kontroll.',
  'km.drivenThisYear': 'Kört i år',
  'km.drivenThisYearHelp': 'Totalt antal kilometer tjänstekörning du har registrerat hittills i år.',
  'km.deductionThisYear': 'Avdrag i år',
  'km.deductionThisYearHelp': 'Total milersättning (avdrag) för årets registrerade resor.',
  'km.searchPh': 'Sök på rutt, syfte eller datum',
  'km.deleteTripTitle': 'Ta bort resan?',
  'km.deleteTripConfirm': 'Ja, ta bort',
  'bank.alreadyPostedToOperating': 'Redan bokförd mot driftskonto',
  'bank.openInJournal': 'Öppna i verifikationslistan',
  'bank.noEntriesInView': 'Inga poster i den här vyn.',
  'bank.fixUp': 'Korrigera',
  'bank.pickLine': 'Välj rad',
  'bank.noFreeLines': 'Inga lediga bankrader i det här kontoutdraget.',
  'bank.link': 'Koppla',
  'bank.statement': 'Kontoutdrag',
  'bank.openOriginal': 'Öppna original',
  'bank.downloadCsv': 'Ladda ner CSV',
  'bank.openingBalance': 'Ingående saldo',
  'bank.originalNotDownloadable': 'Originalfilen kan inte laddas ner.',
  'bank.viewUsesImported': 'Vyn nedan använder de bankrader som redan har importerats.',
  'bank.balance': 'Saldo',
  'bank.noImportedLines': 'Inga importerade bankrader i det här kontoutdraget.',
  'bank.importNoTransactions': 'Hittade inga transaktioner i ”{{fileName}}”, men saldona visar en förändring på {{difference}}. Kontrollera raderna mot originalet innan du stämmer av. Kontoutdraget sparades inte.',
  'bank.importBalanceMismatch': 'Avläsningen stämmer inte med saldona i kontoutdraget: {{difference}} i differens. Kontrollera raderna mot originalet innan du stämmer av. Kontoutdraget sparades inte.',
  'bank.importUnreadablePeriod': 'Kunde inte läsa perioden i kontoutdraget. Kontoutdraget sparades inte.',
  'bank.imageAnalysisUnavailable': 'Bildanalys av kontoutdrag är inte tillgänglig ännu.',
  'bank.importFailed': 'Kunde inte läsa kontoutdraget.',
  'bank.readingStatement': 'Läser kontoutdraget…',
  'bank.openStatementPreview': 'Öppna förhandsgranskning av kontoutdraget',
  'bank.seeOriginal': 'Visa kontoutdrag',
  'bank.almostDone': 'Nästan i mål',
  'bank.linesRemaining': 'rader återstår att hantera',
  'bank.discrepancy': 'Avvikelse',
  'bank.discrepancyHelp': 'Beräknad avvikelse mellan saldo och bankrader',
  'bank.openingBalanceHelp': 'Saldot på bankkontot i början av perioden — hämtat från föregående avstämning.',
  'bank.closingBalanceHelp': 'Saldot på bankkontot i slutet av perioden, enligt kontoutdraget. Det ska stämma med bokfört saldo när alla rader är hanterade.',
  'bank.useSuperPlumma': 'Använd SuperPlumma',
  'bank.useSuperPlummaHelp': 'Låter SuperPlumma hitta förslag att kontrollera. Du godkänner resultatet före bokföring.',
  'bank.reconcileAndPost': 'Stäm av och bokför',
  'bank.chronologicalTitle': 'En tidigare period är inte avstämd',
  'bank.chronologicalBody': 'Stäm av {{period}} först. Ingående saldo hämtas från föregående kontoutdrag, så en avvikelse där skulle bli osynlig här.',
  'bank.reconcileAndPostHelp': 'Bokför bankraderna, låser perioden när alla rader är hanterade och flyttar kontoutdraget till arkivet.',
  'bank.reconcileAndArchive': 'Stäm av och arkivera',
  'bank.reconcileAndArchiveHelp': 'Bokför bankraderna, låser perioden när alla rader är hanterade och flyttar kontoutdraget till arkivet.',
  'bank.existingEntryMatch.action': 'Matcha bokförd post',
  'bank.existingEntryMatch.title': 'Matcha bokförd post',
  'bank.existingEntryMatch.help': 'Välj den post som redan bokför samma bankbelopp. Ingen ny bokföring skapas.',
  'bank.existingEntryMatch.dateMismatch': 'Datumet avviker med {days} dagar. Kontrollera posten innan du kopplar.',
  'bank.existingEntryMatch.none': 'Inga bokförda poster med samma belopp och närliggande datum hittades.',
  'bank.existingEntryMatch.success': 'Bankraden är kopplad till den bokförda posten.',
  'bank.existingEntryMatch.error': 'Kunde inte koppla bankraden.',
  'bank.reopenAndReverse': 'Öppna och återför',
  'bank.reopenAndReverseHelp': 'Öppnar det avstämda kontoutdraget igen så att bokföringen kan rättas. Perioden låses upp.',
  'bank.settledTitle': 'Avstämd och bokförd',
  'bank.settledOn': 'Arkiverad {{date}}',
  'bank.settledHelp': 'Kontoutdraget ligger i arkivet.',
  'bank.settledBadge': 'Avstämd',
  'bank.alreadySettled': 'Kontoutdraget är redan avstämt och arkiverat. Öppna det igen om något behöver rättas.',
  'bank.postedToOperating': 'Bokförd mot driftskonto',
  'bank.postedToOperatingHelp': 'Dessa poster är bokförda på driftskontot för den här bankperioden.',
  'bank.linkVoucher': 'Koppla',
  'bank.openLinkedVoucher': 'Öppna {{name}}',
  'bank.openingBalanceImported': 'Avläst från kontoutdraget: {{amount}}',
  'bank.useExpectedOpening': 'Sätt ingående saldo till {{amount}}',
  'bank.receiptLinked': 'Kopplad till bankrad',
  'bank.duplicateUpload': 'Möjlig dubbeluppladdning',
  'bank.ambiguousMatch': 'Flera likadana verifikationer — välj själv vilken som hör till',
  'bank.linkSuggestedVouchers': 'Koppla {{count}} föreslagna verifikationer',
  'bank.searchLines': 'Sök i bankrader…',
  'bank.addLine': 'Lägg till bankrad',
  'bank.noLinesInView': 'Inga bankrader i den här vyn.',
  'bank.missingVoucher': 'Saknar verifikation',
  'bank.missingVoucherAction': 'Saknar verifikation · klicka eller dra hit',
  'bank.missingVoucherHelp': 'Dra en verifikation från inkorgen hit för att koppla den. Om verifikationen har tappats bort eller inte kan skaffas fram kan du klicka och registrera den som förlorad.',
  'bank.markVoucherLostTitle': 'Markera verifikation som förlorad',
  'bank.markVoucherLostHelp': 'Bokföringen behålls, men detta ersätter inte dokumentation. Uppföljningen stängs och valet sparas på bankraden med motivering, tidpunkt och användare.',
  'bank.markVoucherLostConfirm': 'Registrera',
  'bank.markVoucherLostSaving': 'Registrerar …',
  'bank.voucherLostReason': 'Förklaring',
  'bank.voucherLostReasonHint': 'Obligatoriskt. Förklara varför verifikationen inte kan anskaffas.',
  'bank.voucherLostReasonPlaceholder': 'T.ex. kvittot har tappats bort och leverantören kan inte skicka en kopia.',
  'bank.voucherLostReasonRequired': 'Skriv kort varför verifikationen inte kan anskaffas.',
  'bank.voucherLostError': 'Det gick inte att markera verifikationen som förlorad.',
  'bank.voucherLostUnavailable': 'Markering av förlorad verifikation är inte kopplad till backend.',
  'bank.docReason.lostText': 'Verifikationen är förlorad och kan inte anskaffas.',
  'bank.docReason.never': 'Aldrig mottagen',
  'bank.docReason.neverText': 'Leverantören har inte skickat kvitto eller faktura.',
  'bank.docReason.statementOnly': 'Endast i kontoutdraget',
  'bank.docReason.statementOnlyText': 'Transaktionen finns bara i kontoutdraget och någon egen verifikation finns inte.',
  'bank.docReason.notApplicable': 'Inte aktuellt',
  'bank.docReason.notApplicableText': 'Egen verifikation är inte aktuell för den här bokningen.',
  'bank.voucherMarkedLost': 'Verifikation förlorad',
  'bank.voucherMarkedLostToast': 'Verifikationen är markerad som förlorad',
  'bank.sendVoucherBack': 'Skicka tillbaka verifikationen till inkorgen',
  'bank.approveSuggestion': 'Godkänn förslag',
  'bank.approveSuggestionHelp': 'Godtar SuperPlummas konteringsförslag för raden och bokför den så.',
  'bank.review': 'Kontrollera',
  'bank.markPrivate': 'Markera som privat',
  'bank.post': 'Bokför',
  'bank.reviewEntries': 'Kontrollera poster',
  'bank.previewUnavailable': 'Förhandsgranskning är inte tillgänglig',
  'bank.previewUnavailableHelp': 'Verifikationen saknar en tillgänglig filadress.',
  'bank.noVatCalculated': 'Ingen moms beräknas. Hela bankbeloppet på',
  'bank.amountExVatBecomes': 'Beloppet exkl. moms blir',
  'bank.actualAmountIncVat': 'Faktiskt bankbelopp inkl. moms blir',
  'bank.saveAndClose': 'Spara och stäng',
  'bank.manualLine': 'Manuell bankrad',
  'bank.amountExInc': 'Bankbelopp exkl./inkl. moms',
  'bank.amountExIncHelp': 'Tryck för att växla mellan att visa beloppet med eller utan moms. Plumme räknar om automatiskt, medan det faktiska beloppet från banktransaktionen fortfarande sparas inkl. moms.',
  'bank.costAccount': 'Kostnadskonto',
  'bank.accountCategory': 'Konto/kategori',
  'bank.salesAccount': 'Försäljningskonto',
  'bank.pickOpenInvoice': 'Välj öppen faktura',
  'bank.noMatchingInvoices': 'Inga öppna fakturor matchar det här beloppet.',
  'bank.matchesVatPeriod': 'Matchar vald momsperiod. Bokföring och markering som betald sker när perioden kopplas.',
  'bank.mixedUseManual': 'Om raden blandar moms, skatt, korrigeringar eller andra justeringar, använd fri kontering.',
  'bank.matchesPayrollPeriod': 'Matchar vald period för skatteavdrag/AGA. Välj vilken del bankraden faktiskt betalar.',
  'bank.payrollPeriod': 'Period för skatteavdrag / AGA',
  'bank.whatIsPaymentFor': 'Vad gäller betalningen?',
  'bank.payrollAccountsHelp': 'Skatteavdrag är 2600, arbetsgivaravgift är 2770.',
  'bank.feeHelp': 'Använd detta för bank- och kortavgifter. Beloppet bokförs utan moms mot',
  'bank.noFeeAccount': 'Det finns inget lämpligt avgiftskonto i kontoplanen.',
  'bank.roundingHelp': 'Använd detta bara för en verklig liten avrundningsdifferens. Beloppet bokförs utan moms mot',
  'bank.swapFromTo': 'Byt från och till',
  'bank.pickTwoAccounts': 'Välj två olika konton innan du sparar den fria konteringen.',
  'bank.manualPostingBankMismatch': 'Summan på bankkontot i konteringen måste vara lika med bankraden.',
  'bank.supplierVatHelp': 'Momssatsen på leverantörsfakturan. Ingående moms beräknas från beloppet.',
  'bank.supplierDueDateHelp': 'Förfallodatumet på leverantörens faktura. Om bankraden bara täcker en del av beloppet är resten fortfarande en öppen post — och förfallodatumet är det som åldersfördelningen räknas från.',
  'bank.supplierInvoiceGross': 'Fakturans totalbelopp',
  'set.bank.currency': 'Valuta',
  'set.bank.accountNumberHelp': 'Kontonumret så som banken anger det. Punkter och mellanslag tas bort automatiskt — bokföringen, importfilerna och betalningarna jämför siffrorna, och ett nummer med skiljetecken matchar inte sitt eget kontoutdrag.',
  'set.bank.currencyName.NOK': 'Norska kronor',
  'set.bank.currencyName.SEK': 'Svenska kronor',
  'set.bank.currencyName.DKK': 'Danska kronor',
  'set.bank.currencyName.EUR': 'Euro',
  'set.bank.currencyName.USD': 'Amerikanska dollar',
  'set.bank.currencyName.GBP': 'Brittiska pund',
  'set.bank.currencyName.CHF': 'Schweiziska franc',
  'set.bank.currencyName.ISK': 'Isländska kronor',
  'set.bank.currencyName.PLN': 'Polska zloty',
  'set.bank.currencyName.CZK': 'Tjeckiska koruna',
  'set.bank.currencyName.JPY': 'Japanska yen',
  'set.bank.currencyName.CAD': 'Kanadensiska dollar',
  'set.bank.currencyName.AUD': 'Australiska dollar',
  'set.loans.title': 'Låneregister',
  'set.loans.sub': 'Lån och långfristiga skulder med amorteringsplan',
  'set.loans.help': 'Ett lån är annars bara ett huvudbokskonto. Saldot visar vad som återstår, men inte hur mycket som förfaller nästa år — och utan det kan kortfristiga och långfristiga skulder inte skiljas åt. Amorteringarna bokförs som tidigare, via bank eller verifikation.',
  'set.loans.none': 'Inga lån registrerade.',
  'set.loans.add': 'Lägg till lån',
  'set.loans.remove': 'Ta bort lån',
  'set.loans.lender': 'Långivare',
  'set.loans.ledgerAccount': 'Huvudbokskonto',
  'set.loans.ledgerAccountHelp': 'Kontot som lånet står på. Utan det kan lånet inte stämmas av mot bokföringen.',
  'set.loans.missingAccount': 'Konto saknas',
  'set.loans.originalAmount': 'Ursprungligt lånebelopp',
  'set.loans.interestRate': 'Ränta (%)',
  'set.loans.startDate': 'Startdatum',
  'set.loans.repaymentType': 'Amorteringstyp',
  'set.loans.termsPerYear': 'Terminer per år',
  'set.loans.monthly': 'Månadsvis (12)',
  'set.loans.quarterly': 'Kvartalsvis (4)',
  'set.loans.halfYearly': 'Halvårsvis (2)',
  'set.loans.yearly': 'Årligen (1)',
  'set.loans.installmentAmount': 'Terminsbelopp',
  'set.loans.installmentHelp': 'Amorteringen per termin för rak amortering, hela terminsbeloppet för annuitetslån.',
  'set.loans.remainingTerms': 'Återstående terminer',
  'set.loans.interestOnlyUntil': 'Amorteringsfritt till',
  'set.loans.interestOnlyHelp': 'Lämna tomt om lånet inte har amorteringsfrihet.',
  'set.loans.security': 'Pant och säkerhet',
  'set.loans.planIncomplete': 'Planen är inte tillräckligt komplett för att räkna ut vad som förfaller nästa år. Avstämningen säger till i stället för att gissa.',
  'set.loans.planSays': 'Enligt planen förfaller {amount} under de kommande tolv månaderna. Klassificeringen kortfristig/långfristig är fortfarande en fackmässig bedömning.',
  'set.bank.currencyHelp': 'Kontots egen valuta. NOK för vanliga norska konton. Ett konto i annan valuta stäms av genom omräkning till balansdagens kurs, inte genom direkt jämförelse.',
  'bank.supplierInvoiceGrossHelp': 'Fyll bara i om bankraden täcker en del av fakturan. Då registreras fakturan med sitt fulla belopp, och det bankraden betalar bokförs som en delbetalning — resten står kvar som utestående hos leverantören.',
  'bank.shortDescriptionPh': 'Kort beskrivning av transaktionen…',
  'bank.previewVoucher': 'Förhandsgranska verifikationen',
  'bank.noVoucherUploaded': 'Ingen verifikation uppladdad',
  'bank.fetchFromInbox': 'Hämta från Inkorg',
  'bank.backToBank': 'Tillbaka till bank',
  'bank.privateBank': 'Privat bank',
  'bank.privateBankHelp': 'Privatkontot används som ett städverktyg: gå igenom raderna, markera de som egentligen är företagsutgifter som ”Drift” (de bokförs då på företagskontot) och ignorera de rent privata. På så sätt får du med företagskostnader som du har lagt ut privat.',
  'bank.finishReview': 'Slutför genomgången',
  'bank.finishReviewHelp': 'Bokför raderna du har markerat som verksamhet på verksamhetskontot och arkiverar det färdiggranskade privatkontoutdraget.',
  'bank.dragVoucherFromInbox': 'Dra verifikation från inkorgen',
  'bank.toOperations': 'Till verksamheten',
  'bank.toOperationsHelp': 'Öppnar bokföringsvalen för raden, så att konto, moms, verifikation och typ blir rätt innan den flyttas till verksamheten.',
  'bank.ignore': 'Ignorera',
  'bank.ignoreHelp': 'Markera raden som rent privat och håll den utanför företagets bokföring. Tryck igen för att ångra.',
  'bank.voucherReceivedOn': 'Verifikation mottagen den',
  'bank.superPlummaFetches': 'SuperPlumma hämtar och kopplar',
  'bank.searchInbox': 'Sök i inkorgen...',
  'bank.reopen': 'Öppna igen',
  'bank.viewPostings': 'Visa konteringar',
  'bank.waitingPrevious': 'Väntar på föregående',
  'bank.waitingPreviousHelp': 'Du kan öppna och kontrollera kontoutdraget nu, men det kan inte bokföras eller stämmas av förrän det föregående kontoutdraget är klart.',
  'bank.previousMustReconcile': 'Föregående kontoutdrag måste stämmas av först. Du kan kontrollera det här kontoutdraget, men inte bokföra eller stämma av det än.',
  'bank.openStatement': 'Öppna kontoutdrag',
  'bank.deleteStatement': 'Ta bort kontoutdrag',
  'bank.deleteStatementTitle': 'Ta bort kontoutdrag?',
  'bank.deleteStatementConfirm': '{{fileName}} tas bort permanent. Bokförda poster och verifikationer raderas inte, men förlorar kopplingen till kontoutdraget. De står utan bankavstämning tills du laddar upp ett kontoutdrag för perioden — då matchas de automatiskt eller visas som avvikelser. Detta kan inte ångras.',
  'bank.statementFallback': 'Kontoutdraget',
  'bank.deleteUnavailable': 'Borttagning av kontoutdrag är inte tillgänglig än.',
  'bank.deleteSuccess': 'Kontoutdraget har tagits bort',
  'bank.deleteReopenFirst': 'Öppna kontoutdraget igen innan det tas bort.',
  'bank.deleteNewerFirst': 'Nyare kontoutdrag måste tas bort först. Behandlade kontoutdrag tas bort från nyaste till äldsta.',
  'bank.deleteError': 'Kunde inte ta bort kontoutdraget.',
  'bank.deleteSettledBlocked': 'Avstämda eller bokförda kontoutdrag kan inte tas bort.',
  'bank.deleteReverseFirst': 'Bokföringen måste återföras innan kontoutdraget kan tas bort.',
  'bank.deleteMatchGroupBlocked': 'Kontoutdraget ingår i en bokförd matchningsgrupp. Återför gruppen innan kontoutdraget tas bort.',
  'bank.deleteMatchGroupOffline': 'Kontoutdraget ingår i en matchningsgrupp. Försök igen när du är ansluten.',
  'bank.noArchivedStatements': 'Inga arkiverade kontoutdrag än.',
  'bank.archivedHelp': 'Färdigavstämda perioder hamnar här när alla rader har behandlats och arkiverats.',
  'bank.uploadFile': 'Ladda upp fil',
  'bank.opPrivArchive': 'Verksamhet / Privat / Arkiv',
  'bank.opPrivArchiveHelp': '”Verksamhet” stämmer av företagets verksamhetskonto. ”Privat” används för att städa i ett privatkonto och flytta företagsrelaterade rader till verksamheten. ”Arkiv” visar färdigavstämda kontoutdrag.',
  'bank.privateNotLinked': 'Ett privatkonto är personligt och kopplas inte till företagets bankkonto.',
  'bank.bankAccount': 'Bankkonto',
  'bank.bankAccountHelp': 'Välj vilket bankkonto du stämmer av. Varje konto har sitt eget kontonummer i kontoplanen (t.ex. 1920 verksamhetskonto, 1950 skatteavdragskonto) och sina egna kontoutdrag.',
  'bank.noAccountsSetUp': 'Inga bankkonton har konfigurerats',
  'bank.noStatements': 'Inga kontoutdrag än.',
  'bank.noStatementsHelp': 'Ladda upp en bankfil för valt konto, eller kontrollera att rätt företag är valt.',
  'bank.connectBank': 'Anslut banken',
  'bank.connectBankHelp': 'Anslut Plumme direkt till din bank via säker Open Banking. Då hämtas transaktionerna automatiskt och SuperPlumma bokför och stämmer av löpande — så du slipper ladda upp kontoutdrag manuellt.',
  'bank.connectYourBank': 'Anslut din bank',
  'bank.connect': 'Anslut',
  'altinn.sub': 'Skicka blanketter vidare till myndigheterna — vi fyller i det vi kan i förväg.',
  'altinn.filingVia': 'Inlämning via Altinn',
  'altinn.open': 'Öppna Altinn',
  'altinn.openHelp': 'Öppnar Altinn-portalen i en ny flik, där du loggar in med ditt ID och slutför inlämningen av de förifyllda blanketterna.',
  'altinn.formsAndStatus': 'Blanketter och status',
  'altinn.formsAndStatusHelp': 'Översikt över de offentliga blanketter som företaget ska lämna in, med RF-referensnummer och status. Statusen visar om blanketten är inlämnad, förfaller snart eller inte är inlämnad än.',
  'altinn.form': 'Blankett',
  'altinn.formHelp': 'Namnet på den offentliga blanketten. RF-numret i nästa kolumn är Skatteetatens officiella referens för blanketten.',
  'altinn.statusHelp': '”Inlämnad” har skickats in, ”Förfaller snart” närmar sig fristen och ”Inte inlämnad” återstår att skicka.',
  'setl.sub': 'Företag, fakturering, bank och aviseringar - allt på ett ställe.',
  'setl.companyInfo': 'Företagsuppgifter',
  'setl.companyName': 'Företagsnamn',
  'setl.invoiceSettings': 'Fakturainställningar',
  'setl.nextInvoiceNo': 'Nästa fakturanummer',
  'setl.defaultPaymentTerms': 'Standard betalningsvillkor',
  'setl.defaultVatRate': 'Standard momssats',
  'setl.reminderFee': 'Påminnelseavgift',
  'setl.sendCopyToMe': 'Skicka kopia till mig',
  'setl.sendCopyHelp': 'Få en kopia av varje faktura via e-post.',
  'setl.bankAndAccount': 'Bank och konto',
  'setl.mainLedgerAccount': 'Huvudkonto i bokföringen',
  'setl.notifications': 'Aviseringar',
  'km.pageHelp': 'Körjournalen dokumenterar tjänstekörning och privat användning av förmånsbil. Tjänsteresor ger milersättning enligt statens sats, medan privat körning loggas utan avdrag.',
  'km.newTrip': 'Ny resa',
  'km.tripType': 'Resetyp',
  'km.typeBusiness': 'Tjänst',
  'km.typePrivate': 'Privat',
  'km.privateUse': 'Privat användning',
  'km.privatePurposePh': 'Privat användning (valfritt)',
  'km.privateNote': 'Privat körning loggas, men ger inget avdrag och bokförs inte.',
  'km.ownCar': 'Egen bil',
  'km.startPlace': 'Startplats',
  'km.stopN': 'Stopp {n}',
  'km.stopPh': 'Adress längs vägen',
  'km.destination': 'Destination',
  'km.calculating': 'Beräknar...',
  'km.saveChanges': 'Spara ändringar',
  'km.saveEntry': 'Spara körjournalspost',
  'km.privateDriving': 'Privat körning',
});
